exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".client-container[data-v-391a4218]{position:relative}.client-container .disable-overlay[data-v-391a4218]{position:absolute;top:0;left:0;width:100%;height:100%;display:flex;justify-content:center;align-items:center;background:hsla(0,0%,100%,.9)}", ""]);

// exports
